/* global axios */
import ApiClient from './ApiClient';

class ProjectsAPI extends ApiClient {
  constructor() {
    super('projects', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(data) {
    return axios.post(this.url, { project: data });
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, { project: data });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  applyPlaybook(id, playbookId) {
    return axios.post(`${this.url}/${id}/apply_playbook`, {
      playbook_id: playbookId,
    });
  }

  generateDocumentRequestShare(id) {
    return axios.post(`${this.url}/${id}/document_request_share`);
  }

  revokeDocumentRequestShare(id) {
    return axios.delete(`${this.url}/${id}/document_request_share`);
  }

  getPhases(id) {
    return axios.get(`${this.url}/${id}/phases`);
  }

  createPhase(id, data) {
    return axios.post(`${this.url}/${id}/phases`, { phase: data });
  }

  updatePhase(id, phaseId, data) {
    return axios.patch(`${this.url}/${id}/phases/${phaseId}`, { phase: data });
  }

  deletePhase(id, phaseId) {
    return axios.delete(`${this.url}/${id}/phases/${phaseId}`);
  }

  reorderPhases(id, phaseIds) {
    return axios.patch(`${this.url}/${id}/phases/reorder`, {
      phase_ids: phaseIds,
    });
  }

  phaseBoard(id, phaseId) {
    return axios.get(`${this.url}/${id}/phases/${phaseId}/board`);
  }

  getPipelineStages(id, phaseId) {
    return axios.get(`${this.url}/${id}/phases/${phaseId}/pipeline_stages`);
  }

  createPipelineStage(id, phaseId, data) {
    return axios.post(`${this.url}/${id}/phases/${phaseId}/pipeline_stages`, {
      pipeline_stage: data,
    });
  }

  updatePipelineStage(id, phaseId, stageId, data) {
    return axios.patch(
      `${this.url}/${id}/phases/${phaseId}/pipeline_stages/${stageId}`,
      { pipeline_stage: data }
    );
  }

  deletePipelineStage(id, phaseId, stageId) {
    return axios.delete(
      `${this.url}/${id}/phases/${phaseId}/pipeline_stages/${stageId}`
    );
  }

  reorderPipelineStages(id, phaseId, stageIds) {
    return axios.patch(
      `${this.url}/${id}/phases/${phaseId}/pipeline_stages/reorder`,
      { stage_ids: stageIds }
    );
  }
}

export default new ProjectsAPI();
